import { ProjectType } from '@lopo-tech/lopo-api'
import React from 'react'
import { RouteComponentProps } from 'react-router'
import { ProjectsListPage } from 'src/pages/projects_list'

const InfrastructureProjectsListPage: React.FC<RouteComponentProps> = (props) => (
  <ProjectsListPage {...props} projectType={ProjectType.InfrastructureProject} />
)

export default InfrastructureProjectsListPage
